export default class CoreConfig {
    constructor(rawData = {}) {
        this.id = rawData.id;
        this.configKey = rawData.configKey;
        this.configValue = rawData.configValue;
        this.configType = rawData.configType;
    }
}